module.exports = __webpack_public_path__ + "img/L2_Frame_Door.7081314c.svg";